module.exports = __webpack_public_path__ + "images/emoji/crescent_moon.8ee513551c96f2d8a354.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/crescent_moon.png
// module id = wYmT
// module chunks = 24